import type { BootstrapPayload } from "../../shared/contracts/bootstrap.js";
import type { LocalDatabase, LocalDeviceAccount } from "./round-journal.js";

export class DeviceAccountCache {
  public constructor(private readonly database: LocalDatabase) {}

  public async save(bootstrap: BootstrapPayload): Promise<void> {
    const now = new Date().toISOString();
    const existing = await this.database.deviceAccounts.get(
      bootstrap.account.id,
    );
    await this.database.deviceAccounts.put({
      accountId: bootstrap.account.id,
      email: bootstrap.account.email,
      displayName: bootstrap.profile.displayName,
      bootstrap,
      verifiedAt: existing?.verifiedAt ?? now,
      lastUsedAt: now,
    });
  }

  public get(accountId: string): Promise<LocalDeviceAccount | undefined> {
    return this.database.deviceAccounts.get(accountId);
  }

  public async listRecent(): Promise<LocalDeviceAccount[]> {
    return (await this.database.deviceAccounts.toArray()).sort((left, right) =>
      right.lastUsedAt.localeCompare(left.lastUsedAt),
    );
  }

  public async remove(accountId: string): Promise<void> {
    await this.database.deviceAccounts.delete(accountId);
  }
}
